module.exports = __webpack_public_path__ + "img/collection-weddingRingstrisets.20a653b.jpg";